import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

export interface ICostCenterItem {
  id: number;
  name: string;
  description?: string;
  staffCount: number;
}

export interface ICostCenterListParams {
  keyword?: string;
  pageNo?: number;
  pageSize?: number;
}

export interface ICostCenterListRes {
  pageNo: number;
  pageSize: number;
  totalCount: number;
  result: ICostCenterItem[];
}

/** 获取成本中心列表（支持关键字搜索和分页） */
export const fetchCostCenterList = async (params?: ICostCenterListParams) => {
  const data = await request.get<ICostCenterListRes>(
    `${HOSTS.BASE}/api/entweb/costCenter/list`,
    { params }
  )
  return { success: true, data }
}

export interface ICostCenterCreateItem {
  name: string;
  description?: string;
}

export interface ICostCenterConflictItem {
  name: string;
  existingId: number;
}

export interface ICostCenterCreateRes {
  conflictList?: ICostCenterConflictItem[];
}

/** 批量创建成本中心（单次最多 50 条）
 * 返回 conflictList 表示与已有数据冲突的条目，需前端提示
 */
export const createCostCenter = async (params: {
  costCenterCreateList: ICostCenterCreateItem[];
}) => {
  const data = await request.post<ICostCenterCreateRes>(
    `${HOSTS.BASE}/api/entweb/costCenter/create`,
    params
  )
  return data
}

export const updateCostCenter = async (params: {
  id: number;
  name: string;
  description?: string;
}) => {
  await request.post<void>(
    `${HOSTS.BASE}/api/entweb/costCenter/update`,
    params
  )
}

export const deleteCostCenter = async (params: { id: number }) => {
  await request.post<void>(
    `${HOSTS.BASE}/api/entweb/costCenter/delete`,
    params
  )
}
